<template>
    <div>
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">我的订单</div>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <div style="display: flex; align-items: end; gap: 10px;">
                    <el-form-item label="采购单号" class="form-item-name">
                        <el-input v-model="searchForm.orderNumber" placeholder="请输入" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="采购标题" class="form-item-phone">
                        <el-input v-model="searchForm.orderTitle" placeholder="请输入" size="small"></el-input>
                    </el-form-item>
                    <el-form-item class="form-item-reset">
                        <el-button type="default" size="small" @click="resetSearch">重置</el-button>
                    </el-form-item>
                    <el-form-item class="form-item-search">
                        <el-button type="primary" size="small" @click="searchOrders">查询</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <!-- 订单状态标签 -->
        <div class="status-tabs">
            <el-radio-group v-model="activeStatus" size="small" class="status-radio-group" @change="handleStatusChange">
                <el-radio-button label="0">全部</el-radio-button>
                <el-radio-button label="1">一轮比价</el-radio-button>
                <el-radio-button label="2">一轮询价</el-radio-button>
                <el-radio-button label="3">二轮比价</el-radio-button>
                <el-radio-button label="4">配载中</el-radio-button>
                <el-radio-button label="5">配载完成</el-radio-button>
                <el-radio-button label="6">运输中</el-radio-button>
                <el-radio-button label="7">待收货</el-radio-button>
                <el-radio-button label="8">待结算</el-radio-button>
                <el-radio-button label="-1">已取消</el-radio-button>
            </el-radio-group>
        </div>
        <!-- 订单表格 -->
        <el-table :data="tableData" :border="true" style="width: 100%" class="order-table">
            <el-table-column prop="order_sn" label="采购单号" width="200" align="center"></el-table-column>
            <el-table-column prop="status_name" label="订单状态" width="150" align="center"></el-table-column>
            <el-table-column prop="title" label="采购标题" align="center"> </el-table-column>
            <el-table-column prop="settle_type_name" label="结算周期" width="150" align="center">
            </el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="viewOrderDetail(scope.row)">
                        查看详情
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pagination">
            <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="totalOrders"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :current-page="currentPage"
                @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    name: 'purchaseOrderList',
    data() {
        return {
            // 搜索表单
            searchForm: {
                orderNumber: '',
                orderTitle: ''
            },
            // 状态标签
            activeStatus: '0',
            // 订单列表
            tableData: [],
            // 分页信息
            totalOrders: 0,
            pageSize: 10,
            currentPage: 1
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
    },
    mounted() {
        this.getOrdersList();
    },
    methods: {
        // 获取订单列表
        getOrdersList() {
            this.$api.getPriceComparisonList({
                status: this.activeStatus,
                order_sn: this.searchForm.orderNumber,
                title: this.searchForm.orderTitle,
                page: this.currentPage,
                list_rows: this.pageSize,
            }).then(res => {
                this.tableData = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        // 搜索订单
        searchOrders() {
            this.currentPage = 1;
            this.getOrdersList();
        },
        // 重置搜索条件
        resetSearch() {
            this.searchForm = {
                orderNumber: '',
                orderTitle: ''
            };
            this.currentPage = 1;
            this.getOrdersList();
        },
        // 处理状态标签切换
        handleStatusChange() {
            this.currentPage = 1;
            this.getOrdersList();
        },
        // 查看订单详情
        viewOrderDetail(item) {
            // 触发父组件的事件，传递订单参数
            this.$emit('goToComponent', 'purchaseOrderDetail', {
                aid: item.aid,
            });
        },
        // 分页相关
        handleSizeChange(val) {
            this.pageSize = val;
            this.getOrdersList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getOrdersList();
        }
    }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.my-orders-container {
    background-color: #fff;
    border-radius: 8px;
    margin: 0 auto;
    padding: 20px;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 搜索区域 */
.search-section {
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.search-form {
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: start;
}

/* 为每个表单项目设置固定宽度 */
.form-item-order-id {
    width: 200px;
    text-align: left;
}

.form-item-name {
    width: 200px;
    text-align: left;
}

.form-item-phone {
    width: 200px;
    text-align: left;
}

.form-item-date {
    width: 300px;
    text-align: left;
}

/* 确保输入框和日期选择器占满表单项目宽度 */
.search-form .el-input,
.search-form .el-date-editor {
    width: 100%;
}

/* 订单状态标签 */
.status-tabs {
    margin-bottom: 20px;
}

.status-radio-group {
    display: flex;
    align-items: center;
}

::v-deep .el-radio-button__original-radio:checked+.el-radio-button__inner {
    background-color: #286CED;
    border-color: #286CED;
}

/* 表格自定义样式 */
.order-table {
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

.order-header {
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.goods-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
    margin-right: 15px;
}

.goods-details {
    min-height: 80px;
    flex: 1;
    text-align: left;
    margin-right: 32px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.goods-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    font-size: 12px;
    color: #999;
}

/* 买家信息样式 */
.buyer-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
}

.buyer-name {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 5px;
}

.buyer-phone {
    font-weight: 500;
    font-size: 14px;
    color: #221E1F;
}

/* 金额样式 */
.amount-label {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 5px;
}

.amount-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

/* 状态样式 */
.status-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.status-text {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

.status-countdown {
    font-size: 12px;
    color: #ff4d4f;
}

/* 交易操作按钮样式 */
.trade-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    justify-content: center;
    height: 100%;
}

/* 按钮样式 */
.primary-btn {
    background-color: #286CED;
    border-color: #286CED;
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.default-btn {
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.text-btn {
    font-size: 14px;
    color: #286CED;
}

/* 分页样式 */
.pagination {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .trade-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }

    .search-form {
        flex-wrap: wrap;
    }

    .form-item-order-id,
    .form-item-name,
    .form-item-phone,
    .form-item-date {
        width: calc(50% - 5px);
    }
}
</style>